import React from "react";
import { Map } from "immutable";

import AppConstants from "../../constants/AppConstants";
import GallerySimple from "./GallerySimple.jsx";
import GalleryTiledWidget from "./GalleryTiledWidget.jsx";
import GallerySlidingWidget from "./GallerySlidingWidget.jsx";
import PlaceholderBackground from "../utils/PlaceholderBackground.jsx";

const PLACEHOLDER_ICON = (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 24 24"
    enableBackground="new 0 0 24 24"
    style={{ width: "100%", height: "100%" }}
  >
    <g fill="#fff">
      <path d="M23,6h-2v2h1v12H6v-1H4v2c0,0.5,0.5,1,1,1h18c0.5,0,1-0.5,1-1V7C24,6.5,23.5,6,23,6z" />
      <circle cx="5" cy="7" r="1.4" />
      <path
        d="M19,2H1C0.5,2,0,2.5,0,3v14c0,0.5,0.5,1,1,1h18c0.5,0,1-0.5,1-1V3C20,2.5,19.5,2,19,2z M18,4v6.3l-3.6-2.7
                                    c0,0-0.8-0.8-1.5-0.8c-0.8,0-1.5,0.8-1.5,0.8s-2.1,2.4-2.8,3.2c1.3,0.5,3.2,3.7,1.7,2.8c-1.5-0.9-4-2-4-2L2,14.6V4H18z"
      />
    </g>
  </svg>
);

const Gallery = (props) => {
  const { content = Map() } = props;
  const type = content.get("type", AppConstants.ELEMENT_GALLERY_TYPE_SIMPLE);
  let view = null;

  const items = content.get("items", false);
  if (!items || items.count() === 0) {
   
    const placeholderInstrux = <span>Add gallery images in properties panel&nbsp;&#8594;</span>;
    return (
      <div>
        <PlaceholderBackground icon={PLACEHOLDER_ICON} instrux={placeholderInstrux} />
      </div>
    );
  }

  switch (type) {
    case AppConstants.ELEMENT_GALLERY_TYPE_SIMPLE:
      view = <GallerySimple {...props} />;
      break;
    case AppConstants.ELEMENT_GALLERY_TYPE_TILE:
      view = <GalleryTiledWidget {...props} />;
      break;
    case AppConstants.ELEMENT_GALLERY_TYPE_SLIDING:
      view = <GallerySlidingWidget {...props} />;
      break;
    default:
      view = null;
  }

  return view;
};

export default Gallery;
